<template>
    <div class="kanban-container">
        <div class="header-content">
            <img src="" class="logo-icon">
            <div class="title">广告只能发布大数据平台</div>
        </div>
        <div class="body">
            <div class="left">
                <h1>文字列表</h1>
                <div class="ad-list-content">
                    <words-roll :list="adList"></words-roll>
                </div>
                
                <h1>图片列表</h1>
                <div class="custom-list-content">
                    <img-roll :list="imgList"></img-roll>
                </div>

                <h1>柱状图</h1>
                <div class="custom-spread-content">
                    <bar-charts :list="industryList"></bar-charts>
                </div>
            </div>

            <div class="middle">
                <h1>中国地图</h1>
                <div class="map-content">
                    <china-map :list="provinceList"></china-map>
                </div>
            </div>

            <div class="right">
                <h1>饼状图</h1>
                <div class="screen-spread-content">
                    <circle-charts :list="screenList"></circle-charts>
                </div>

                <h1>柱状图</h1>
                <div class="LED-state-content">
                    <double-bar-charts
                        :list="doubleYList"
                        :legendData="[{name:'设备数量', type:'deviceCount'}, {name:'播放次数', type:'playCount'}]">
                    </double-bar-charts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import wordsRoll from "../components/kanban/WordsRoll.vue";
import imgRoll from "../components/kanban/ImgRoll.vue";
import BarCharts from "../components/kanban/BarCharts.vue";
import ChinaMap from "../components/kanban/ChinaMap.vue";
import CircleCharts from "../components/kanban/CircleCharts.vue";
import DoubleBarCharts from "../components/kanban/DoubleBarCharts.vue";

// import axios from "axios";
export default {
    name: "Kanban",
    components: {
        wordsRoll,
        imgRoll,
        BarCharts,
        ChinaMap,
        CircleCharts,
        DoubleBarCharts
    },
    data(){
        return{
            adList:[{
                time: "2020-10-10",
                name: "贝壳网293847506",
                point: "1303",
                people: "9093"
            }, {
                time: "2020-10-08",
                name: "京东双十一大促销",
                point: "1636",
                people: "4530"
            }, {
                time: "2020-10-04",
                name: "花希子品牌宣传",
                point: "4562",
                people: "3356"
            }, {
                time: "2020-09-28",
                name: "成都国际车展宣传片",
                point: "5427",
                people: "3141"
            }, {
                time: "2020-09-22",
                name: "金龙鱼食用油宣传片",
                point: "9385",
                people: "8128"
            }, {
                time: "2020-09-17",
                name: "联合丽华飘柔洗发水",
                point: "1024",
                people: "8339"
            }, {
                time: "2020-09-16",
                name: "小龙坎火锅底料广告",
                point: "8031",
                people: "8399"
            }],
            // 图片滚动
            imgList:[
                {name: "易售科技", icon: "http://mjdata.linkzl.com/uploads/default/201130/09403330604.png"},
                {name: "新潮传媒", icon: "http://mjdata.linkzl.com/uploads/default/201130/09401151472.png"},
                {name: "小米科技", icon: "http://mjdata.linkzl.com/uploads/default/201130/09413845013.png"},
                {name: "藏宝天下", icon: "http://mjdata.linkzl.com/uploads/default/201130/09414508213.png"},
                {name: "华为手机", icon: "http://mjdata.linkzl.com/uploads/default/201130/09415387160.png"},
                {name: "丰田汽车", icon: "http://mjdata.linkzl.com/uploads/default/201130/09423432536.png"},
                {name: "海澜之家", icon: "http://mjdata.linkzl.com/uploads/default/201130/09424522548.png"},
                {name: "康师傅", icon: "http://mjdata.linkzl.com/uploads/default/201130/09430062203.png"}
            ],
            // bar相关数据
            industryList: [],
            // 地图展示相关的数据
            provinceList: [],
            // 饼图相关的数据
            screenList: [],
            // 双 Y 轴的柱状图的数据
            doubleYList: []
        }
    },
    mounted(){
        this.$http.get("http://localhost:8081/industryList").then(res => {
            // console.log(res, "res");
            this.industryList = res.data;
        });

        this.$http.get("http://localhost:8081/province").then(res => {
            // console.log(res, "res");
            this.provinceList = res.data;
        });

        this.$http.get("http://localhost:8081/screenList").then(res => {
            this.screenList = res.data;
        });

        this.$http.get("/data/board/monitor").then(res => {
            console.log(res, "res");
            this.doubleYList = res.data;
        })
    }
}
</script>

<style lang="scss" scoped>
.kanban-container{
    display: flex;
    flex-direction: column;
    height:1080px;
    width: 100%;
    overflow: hidden;
    // background-color: pink;
    .header-content{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        .logo-icon{

        }
    }
    .body{
        display: flex;
        flex:1;
        .left{
            width:400px;
            .ad-list-content{
                width: 100%;
                height: 260px;
            }
            .custom-list-content{
                width: 100%;
                height: 160px;
            }
            .custom-spread-content{
                width: 100%;
                height:460px;
            }
        }

        .middle{
            flex: 1;
            .map-content{
                // width: 925px;
                width: 100%;
                height: 615px;
            }
        }

        .right{
            width:400px;
            .screen-spread-content{
                width:100%;
                height:300px;
                background-color: pink;
            }
            .LED-state-content{
                width: 100%;
                height: 400px;
            }
        }
    }
}
</style>